// extracted by mini-css-extract-plugin
export default {"section":"_1_G4O3hk","image":"yIB-dwtd","hide":"_3jnuEBMV","text":"_1U-ZH1vS","title":"_3DFmo8BD","subtitle":"_28QqlA3y"};